import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import "../index.css"

// Inputs
import { TextAreaField, Button, CheckboxField } from '../../../helpers'

//utils
import { round } from '../../../utils';

// common
import Loading from "../../../common/Loading"

// components
import DNSellerPOItemsList from './DNSellerPOItemsList';
import DNBuyerInvoiceItems from './DNBuyerInvoiceItems';


// Apis
import { insertBuyerDebitNote } from '../../../services/api/adjustmentNotes';

// redux
import { raiseToast } from '../../../services/redux/reducers/toast/toast';



const CreateDebitNote = (props) => {

    const dispatch = useDispatch()

    const { buyerInvoice, buyerDebitNotes, userId, adjustmentReasons } = props

    const [selectedBuyerInvoiceItemIds, setSelectedBuyerInvoiceItemIds] = useState([])
    const [buyerInvoiceItemsPIPunch, setBuyerInvoiceItemsPIPunch] = useState(props.buyerInvoiceItemsPIPunch)
    const [isLogisticsCharge, setIsLogisticsCharge] = useState(false)
    const [isLoaderVisible, setIsLoaderVisible] = useState(false)
    const [remarks, setRemarks] = useState('')
    const [isNextButtonClicked, setIsNextButtonClicked] = useState(false)
    const [selectedBuyerInvoiceItemsPIPunch, setSelectedBuyerInvoiceItemsPIPunch] = useState([])
    const [selectedItemsReplacementLog, setSelectedItemsReplacementLog] = useState([])

    const navigate = useNavigate()

    useEffect(() => {
        setBuyerInvoiceItemsPIPunch(props.buyerInvoiceItemsPIPunch);
    }, [props.buyerInvoiceItemsPIPunch])
    

    const handleSubmitDebitNote = async() => {
    
        if (selectedBuyerInvoiceItemIds.length == 0 && !isLogisticsCharge) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select products", life: 3000 }))
        }

        if (!remarks || remarks.trim() === "") {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter remarks", life: 3000 }))
        }

        let qtyErrorBuyerInvoiceItems = []
        selectedBuyerInvoiceItemsPIPunch.map(eachBuyerInvoiceItem=>{
            if (!eachBuyerInvoiceItem.debitNoteProductQuantity) {
                qtyErrorBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter quantity for " + eachBuyerInvoiceItem.productName + " | " + eachBuyerInvoiceItem.productSpecification, life: 3000 }))
            }

            let totalSpoDebitNoteQty = 0
            eachBuyerInvoiceItem.sellerPOItems.map(eachSellerPOItem => {
                eachSellerPOItem.piPunchItems.map(eachPIPunchItem => totalSpoDebitNoteQty += parseFloat(eachPIPunchItem.spoProductPiPunchDebitNoteQty))
            })
            
            if (totalSpoDebitNoteQty === 0) {
                qtyErrorBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter seller po product quantity for  " + eachBuyerInvoiceItem.productName + " | " + eachBuyerInvoiceItem.productSpecification, life: 3000 }))
            } else {
                if (totalSpoDebitNoteQty > eachBuyerInvoiceItem.debitNoteProductQuantity || totalSpoDebitNoteQty < eachBuyerInvoiceItem.debitNoteProductQuantity) {
                    qtyErrorBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                    return dispatch(raiseToast({ severity: 'warn', detail: "Total of entered seller po product qty " + totalSpoDebitNoteQty + " should be equal to entered debit note product qty " + eachBuyerInvoiceItem.debitNoteProductQuantity + " for " + eachBuyerInvoiceItem.productName + " | " + eachBuyerInvoiceItem.productSpecification, life: 3000 }))
                }
            }
        })

        if (qtyErrorBuyerInvoiceItems.length != 0) {
            return false
        }

        if (window.confirm("Confirm to Debit Note")) {

            let newDebitNoteObj = {
                adjustmentTypeId: 2,
                remarks: remarks,
                createdBy: userId,
                companyId: buyerInvoice.companyId,
                branchId: buyerInvoice.branchId,
                buyerInvoiceId: buyerInvoice?.buyerInvoiceId,
                linkedAdjustmentNoteId: 1, //linked BCN Id for SDN,
                sellerPIPunchItems: [],
                updatedAt: new Date(),
                statusId: 7,
                supplyTypeId: buyerInvoice?.supplyTypeId
            }

            if(isLogisticsCharge){
                newDebitNoteObj.adjustedLogisticsbeforeTax = buyerInvoice.logisticsBeforeTax
                newDebitNoteObj.adjustedLogisticsGSTRate = buyerInvoice.logisticsGSTRate
                newDebitNoteObj.adjustedLogisticsWithTax = buyerInvoice.logisticsWithTax
            }

            selectedBuyerInvoiceItemsPIPunch.map((eachBuyerInvoiceItem) => {
                if (selectedBuyerInvoiceItemIds.includes(eachBuyerInvoiceItem.buyerInvoiceItemId)) {
                    eachBuyerInvoiceItem.sellerPOItems.forEach((sellerPOItem) => {
                        sellerPOItem.piPunchItems.forEach((piPunchItem) => {
                            if(piPunchItem.spoProductPiPunchDebitNoteQty){
                                newDebitNoteObj.sellerPIPunchItems.push({
                                    buyerInvoiceItemId: eachBuyerInvoiceItem.buyerInvoiceItemId,
                                    sellerPIPunchItemId: piPunchItem.sellerPIPunchItemId,
                                    adjustedQty: piPunchItem.spoProductPiPunchDebitNoteQty,
                                    adjustedPricePerUnit: eachBuyerInvoiceItem.companyQtyMultiplier ? round(eachBuyerInvoiceItem.debitNoteUnitPrice * eachBuyerInvoiceItem.companyQtyMultiplier) : eachBuyerInvoiceItem.debitNoteUnitPrice,
                                    createdBy: userId
                                })
                            }
                        })
                    })
                }
            })
            
            setIsLoaderVisible(true)
            const addAdjustmentNoteResponse = await insertBuyerDebitNote({adjustmentNoteObj: newDebitNoteObj, buyerInvoice, documentName:"Buyer Debit Note", docItemReplacementLogsData: selectedItemsReplacementLog}) //doGeneratePDF: true
            console.log("addAdjustmentNote-Response", addAdjustmentNoteResponse)

            if(addAdjustmentNoteResponse.failure) {
                setIsLoaderVisible(false)
                return dispatch(raiseToast({severity:'error', detail: addAdjustmentNoteResponse.data.error, life: 3000}))
            }
            else{ 
                props.setIsCreateDebitNoteVisible(false)
                dispatch(raiseToast({severity:'success', detail: "Debit Note added successfully", life: 3000}))
                navigate(`/buyer-debit-note/${addAdjustmentNoteResponse?.data?.adjustmentNoteId}`)
            }
            setIsLoaderVisible(false)
        }
    }

    const handleSelectAllBuyerInvoiceItems = (event) => {
        let buyerInvoiceItemIds = []
        if (event.target.checked) {
            buyerInvoiceItemIds = buyerInvoiceItemsPIPunch.map(eachBuyerInvoiceItem => {
                if (eachBuyerInvoiceItem.isReplaced) {
                    return eachBuyerInvoiceItem.replacedBuyerInvoiceItemId
                }
                return eachBuyerInvoiceItem.buyerInvoiceItemId
            })
        }

        setSelectedBuyerInvoiceItemIds(buyerInvoiceItemIds)
    }

    const handleSelectBuyerInvoiceItem = (event, selectedBuyerInvoiceItemId) => {
        if (event.target.checked) {
            selectedBuyerInvoiceItemIds.push(selectedBuyerInvoiceItemId)
            setSelectedBuyerInvoiceItemIds([...selectedBuyerInvoiceItemIds])
        } else {
            let relatedSelectedBuyerInvoiceItemIds = selectedBuyerInvoiceItemIds.filter(eachBuyerInvoiceItemId => eachBuyerInvoiceItemId !== selectedBuyerInvoiceItemId)
            setSelectedBuyerInvoiceItemIds([...relatedSelectedBuyerInvoiceItemIds])
        }
    }

    const handleOnClickNextButton = (event) => {
        if (selectedBuyerInvoiceItemIds.length == 0 && !isLogisticsCharge) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select products", life: 3000 }))
        }

        if (!remarks || remarks.trim() === "") {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter remarks", life: 3000 }))
        }

        let relatedSelectedBuyerInvoiceItems = buyerInvoiceItemsPIPunch.filter(eachBuyerInvoiceItem => selectedBuyerInvoiceItemIds?.includes(eachBuyerInvoiceItem.isReplaced ? eachBuyerInvoiceItem.replacedBuyerInvoiceItemId : eachBuyerInvoiceItem.buyerInvoiceItemId))

        let qtyErrorBuyerInvoiceItems = []
        relatedSelectedBuyerInvoiceItems.map(eachBuyerInvoiceItem => {
            if (!eachBuyerInvoiceItem.debitNoteProductQuantity) {
                qtyErrorBuyerInvoiceItems.push(eachBuyerInvoiceItem)
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter quantity for " + eachBuyerInvoiceItem.productName + " | " + eachBuyerInvoiceItem.productSpecification, life: 3000 }))
            }
        })

        if (qtyErrorBuyerInvoiceItems.length != 0) {
            return false
        }

        setIsLoaderVisible(true)

        let selectedBuyerInvoiceItemsReplacementLog = []
        let relatedBuyerInvoiceItemsPIPunch = buyerInvoiceItemsPIPunch?.filter(eachBuyerInvoiceItem => selectedBuyerInvoiceItemIds.includes(eachBuyerInvoiceItem.buyerInvoiceItemId))

        relatedBuyerInvoiceItemsPIPunch = JSON.parse(JSON.stringify(relatedBuyerInvoiceItemsPIPunch))
        
        relatedBuyerInvoiceItemsPIPunch?.map(eachBuyerInvoiceItem => {
            if(eachBuyerInvoiceItem.companyQtyMultiplier){
                eachBuyerInvoiceItem.qty = round(parseFloat(eachBuyerInvoiceItem.qty) / eachBuyerInvoiceItem.companyQtyMultiplier)
                eachBuyerInvoiceItem.availableDebitNoteQty = round(parseFloat(eachBuyerInvoiceItem.availableDebitNoteQty) / eachBuyerInvoiceItem.companyQtyMultiplier)
                eachBuyerInvoiceItem.debitNoteProductQuantity = round(parseFloat(eachBuyerInvoiceItem.debitNoteProductQuantity) / eachBuyerInvoiceItem.companyQtyMultiplier)
            }
            return eachBuyerInvoiceItem
        })

        buyerInvoiceItemsPIPunch.forEach(eachBuyerInvoiceItem => {
            if(eachBuyerInvoiceItem.isReplaced && selectedBuyerInvoiceItemIds.includes(eachBuyerInvoiceItem?.replacedBuyerInvoiceItemId)){
                if(eachBuyerInvoiceItem?.relatedDocItemReplacementLog){
                    let docItemReplacementLog = {
                        docItemReplacementMapId: eachBuyerInvoiceItem.docItemReplacementMapId,
                        docNo: eachBuyerInvoiceItem.docNo,
                        unitPrice: eachBuyerInvoiceItem.debitNoteUnitPrice,
                        qtyReplaced: eachBuyerInvoiceItem.debitNoteProductQuantity,
                        GSTRate: eachBuyerInvoiceItem.GSTRate,
                    }

                    selectedBuyerInvoiceItemsReplacementLog.push(docItemReplacementLog)
                }

                eachBuyerInvoiceItem.replacedBuyerInvoiceItems.forEach(relatedReplacedBuyerInvoiceItem => {
                    let eachUnreplaceBuyerInvoiceItem = relatedBuyerInvoiceItemsPIPunch.find(item => item.buyerInvoiceItemId === relatedReplacedBuyerInvoiceItem.buyerInvoiceItemId)

                    if (eachUnreplaceBuyerInvoiceItem) {
                        eachUnreplaceBuyerInvoiceItem.qty = round(parseFloat(eachUnreplaceBuyerInvoiceItem.qty) + parseFloat(relatedReplacedBuyerInvoiceItem.qty));
                        eachUnreplaceBuyerInvoiceItem.availableDebitNoteQty = round(parseFloat(eachUnreplaceBuyerInvoiceItem.availableDebitNoteQty) + parseFloat(relatedReplacedBuyerInvoiceItem.availableDebitNoteQty))
                        eachUnreplaceBuyerInvoiceItem.debitNoteProductQuantity = round(parseFloat(eachUnreplaceBuyerInvoiceItem.debitNoteProductQuantity) + parseFloat(relatedReplacedBuyerInvoiceItem.debitNoteProductQuantity))
                    } else {
                        relatedBuyerInvoiceItemsPIPunch.push(relatedReplacedBuyerInvoiceItem)
                    }
                })
            }
        })

        setSelectedBuyerInvoiceItemsPIPunch([...relatedBuyerInvoiceItemsPIPunch])
        setSelectedItemsReplacementLog(selectedBuyerInvoiceItemsReplacementLog)
        setIsLoaderVisible(false)
        setIsNextButtonClicked(true)
    }

    const handleOnClickBackButton = (event) => {
        setIsLoaderVisible(true)
        setIsNextButtonClicked(false)
        setIsLoaderVisible(false)
    }

    const handleChangeRemarks = (event) => {
        setRemarks(event.target.value)
    }

    let isInvoiceCancelled = false
    if (buyerInvoice.isCancelled) {
        isInvoiceCancelled = true
    }

    let isLogisticsInDebitNote = false
    if (buyerInvoice.logisticsBeforeTax) {
        buyerDebitNotes.map(eachdebitNote => {
            if (eachdebitNote.adjustedLogisticsbeforeTax && eachdebitNote.statusId) {
                isLogisticsInDebitNote = true
            }
        })
    }

    return (
        <div className='credit-note-dialog'>
            {
                !isNextButtonClicked ?
                    <>
                        <label style={{ color: "#343840", fontWeight: "bold", fontSize: "13px" }}>
                            Select Products:
                        </label>
                        {
                            buyerInvoiceItemsPIPunch.length > 0 ?
                                <div className="p-card py-2">
                                    <label>
                                        <CheckboxField
                                            name={'selectAll'}
                                            label={"Select All"}
                                            checked={selectedBuyerInvoiceItemIds.length === buyerInvoiceItemsPIPunch?.length}
                                            onChange={handleSelectAllBuyerInvoiceItems}
                                        />
                                    </label>
                                    {
                                        buyerInvoiceItemsPIPunch.map((eachBuyerInvoiceItem, index) => {
                                            return (
                                                <DNBuyerInvoiceItems
                                                    buyerInvoiceItem={eachBuyerInvoiceItem}
                                                    selectedBuyerInvoiceItemIds={selectedBuyerInvoiceItemIds}
                                                    handleSelectBuyerInvoiceItem={handleSelectBuyerInvoiceItem}
                                                    buyerInvoiceItemsPIPunch={buyerInvoiceItemsPIPunch}
                                                    setBuyerInvoiceItemsPIPunch={setBuyerInvoiceItemsPIPunch}
                                                />
                                            )
                                        })
                                    }
                                    {
                                        !isLogisticsInDebitNote && buyerInvoice.logisticsBeforeTax ?
                                            <div>
                                                <br />
                                                <label>
                                                    <CheckboxField
                                                        name={'logisticCharge'}
                                                        label={"Logistics Charge"}
                                                        checked={isLogisticsCharge}
                                                        onChange={(event) => setIsLogisticsCharge(event.target.checked)}
                                                    />
                                                </label>
                                                <br />
                                            </div>
                                            : null
                                    }
                                </div>
                                : ""
                        }
                        <div style={{ marginTop: "10px", marginBottom: "20px" }}>
                            <label style={{ color: "#343840", fontWeight: "bold", fontSize: "13px" }}>
                                Remarks
                            </label>
                            <div className="flex flex-column text-area">
                                <TextAreaField name="remarks" placeholder="Enter remarks" rows={2} onChange={(e) => handleChangeRemarks(e)} value={remarks} />
                            </div>
                        </div>
                        {/* <div className='mt-3 flex justify-content-end'>
                                <Button className="small-btn" label="Create" onClick={handleSubmitDebitNote} />
                        </div> */}
                        <div className='mt-3 flex justify-content-end'>
                            <Button label={"NEXT"} onClick={(event) => handleOnClickNextButton(event)} />
                        </div>
                    </>
                    :
                    <>
                        <label style={{ color: "#343840", fontWeight: "bold", fontSize: "13px" }}>
                            PI Punch for selected Products:
                        </label>
                        {
                            selectedBuyerInvoiceItemsPIPunch.length > 0 ?
                                <div className="p-card py-2">
                                    {
                                        selectedBuyerInvoiceItemsPIPunch.map((eachDebitNoteItem, index) => {
                                            return (
                                                <DNSellerPOItemsList
                                                    buyerInvoiceItemsPIPunch={buyerInvoiceItemsPIPunch}
                                                    buyerInvoiceItem={eachDebitNoteItem}
                                                    selectedBuyerInvoiceItemIds={selectedBuyerInvoiceItemIds}
                                                    handleSelectBuyerInvoiceItem={handleSelectBuyerInvoiceItem}
                                                    setBuyerInvoiceItemsPIPunch={setBuyerInvoiceItemsPIPunch}
                                                    selectedBuyerInvoiceItemsPIPunch={selectedBuyerInvoiceItemsPIPunch}
                                                    setSelectedBuyerInvoiceItemsPIPunch={setSelectedBuyerInvoiceItemsPIPunch}
                                                />
                                            )
                                        })
                                    }
                                </div>
                                : ""
                        }
                        <div className='mt-3 flex justify-content-end'>
                            <Button className="mr-3" label={ "Back" } onClick={(event)=> handleOnClickBackButton(event)} />
                            <Button className="small-btn" label="Create" onClick={handleSubmitDebitNote} />
                        </div>
                    </>

            }
            <Loading visible={isLoaderVisible} />
        </div>
    )
}

export default CreateDebitNote